export default __webpack_public_path__ + "static/media/CapaInviteGroup.52550c0c.svg";